<template>
  <div class="justify-content-center text-left dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-12">
        <h2 v-if="reservations.length > 0">
          {{ $t('routes.Reservations') }} {{ reservations[0].customer }}
        </h2>
      </div>
      <div class="col-4 dp02 p-2"
           v-for="res of reservations"
           :key="res.id">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.From') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              v-model="res.consultationStart"
              class="myInput" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('common.To') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              v-model="res.consultationEnd"
              class="myInput" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.doctor') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              v-model="res.doctor"
              class="myInput" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.reservationType') }}:</label>
          </div>
          <div class="col-lg-9">
            <ReservationTypeInput
              v-model="res.reservationType"
              :disabled="true"
              class="myInput" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReservationTypeInput from '@components/input/ReservationTypeInput';

export default {
  name: 'CustomerViewDetail',
  components: {
    ReservationTypeInput
  },
  data() {
    return {
      ready: false,
      reservations: []
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  created() {
    this.fetchReservations();
  },
  methods: {
    fetchReservations() {
      this.axios.get('admin/customers/customerconsultations', {
        params: {
          Id: this.id
        }
      })
        .then((res) => {
          if (res.data.result.length > 0) {
            this.reservations = res.data.result;
            this.reservations.forEach((x) => {
              x.consultationEnd = this.$moment(x.consultationStart).add({ hours: (Number)(x.conslultationLength.split(':')[0]) }).format('DD.MM.YYYY HH:mm');
              x.consultationStart = this.$moment(x.consultationStart).format('DD.MM.YYYY HH:mm');
            });
            this.ready = true;
            Promise.resolve(true);
          } else {
            this.$router.push({ name: 'admin.customers.viewdetail', params: { id: this.id } });
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
